<template>
    <div class="providerAdminValidateLogs">
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                small
                elevation="10"
                class="white--text"
                style="font-size: 30px; background-color: #009688; padding: 10px; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiWindowMaximize }}
            </v-icon>
            <span>Validation Logs</span>
        </h1>
        <v-card
            class="docInfoBody"
            elevation="10"
            style="margin: 2% auto 0 auto; position: relative;"
        >
            <v-card-title style="height: 50px; ">
                <v-row style="height: 50px;">
                    <v-col cols="8" style="margin: 0; padding: 0">
                        <v-card style="margin: 0; padding: 20px" elevation="2">
                            <v-row>
                                <v-col cols="4" style="height: 45px;">
                                    <v-text-field
                                        v-model="frDate"
                                        dense
                                        color="teal darken-1"
                                        type="date"
                                        label="FR DATE"
                                        :disabled="currentItem === 'tab-LOGIN LIST' || loading"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4" style="height: 45px;">
                                    <v-text-field
                                        v-model="toDate"
                                        dense
                                        color="teal darken-1"
                                        type="date"
                                        label="TO DATE"
                                        :disabled="currentItem === 'tab-LOGIN LIST' || loading"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="2" style="padding: 0; margin-top: 7px; text-align: center;">
                                    <v-btn
                                        :disabled="currentItem === 'tab-LOGIN LIST' || loading"
                                        style="min-width: 0; width: 10px; padding: 17px 21px;"
                                        color="teal darken-1 white--text"
                                        @click="getData(currentItem, {FR_DATE: frDate, TO_DATE: toDate})"
                                    >
                                        <v-icon>{{ mdiFilter }}</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="2" style="padding: 0; margin-top: 7px;">
                                    <v-btn
                                        :disabled="loading"
                                        style="min-width: 0; width: 10px; padding: 17px 21px;"
                                        color="teal darken-1 white--text"
                                        @click="downloadReportProvider()"
                                    >
                                        <v-icon>{{ mdiDownload }}</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="4" style="height: 45px; padding-top: 22px;">
                        <v-text-field
                            v-model="searchQuery"
                            dense
                            :disabled="loading"
                            color="teal darken-1"
                            :append-icon="mdiMagnify"
                            clearable
                            label="Search"
                            @click:append="search=searchQuery"
                            @keydown.enter="search=searchQuery"
                            @click:clear="search=''"
                        />
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-subtitle style="margin-top: 20px; height: 50px; padding: 0">
                <v-tabs
                    v-model="currentItem"
                    slider-color="teal darken-1"
                    grow
                    color="teal darken-1"
                >
                    <v-tab
                        v-for="item in items"
                        :key="item"
                        :disabled="loading"
                        :href="'#tab-' + item"
                    >
                        {{ item }}
                    </v-tab>
                </v-tabs>
            </v-card-subtitle>
            <v-tabs-items v-model="currentItem">
                <v-tab-item
                    v-for="itemTab in items"
                    :key="itemTab"
                    :value="'tab-' + itemTab"
                >
                    <span
                        v-if="currentItem === 'tab-APPROVAL LOGS'"
                        style="background-color: white; color: #666; position: absolute; right: 0; height: 54.80px; width: 78px; border-radius: 0 5px 0 0; text-align: center; font-family: Montserrat, sans-serif; font-size: 12px; font-weight: 600; padding-top: 17px; border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                    >Action</span>
                    <v-data-table
                        :search="search"
                        :loading="loading ? '#009688' : null"
                        dense
                        :items="data"
                        :headers="modifiedHeaders"
                        :class="`nowrap-table ${currentItem === 'tab-APPROVAL LOGS' ? 'approvalTbl' : ''}`"
                    >
                        <template #item="{ item }">
                            <tr>
                                <td
                                    v-for="(key, index) in modifiedHeaders"
                                    :key="index"
                                    style="white-space: nowrap;"
                                >
                                    {{ item[key.value] }}
                                </td>
                                <td v-if="currentItem === 'tab-APPROVAL LOGS'">
                                    <v-btn
                                        :disabled="loading"
                                        style="min-width: 0; padding: 0 10px; margin: 0"
                                        color="teal darken-1"
                                        class="white--text"
                                        @click="downloadOpan(item)"
                                    >
                                        <v-icon>{{ mdiDownload }}</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
import { moment } from '../../../../utils/date-shim'
import {
    mdiWindowMaximize,
    mdiFilter,
    mdiDownload,
    mdiMagnify
} from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
export default {
    data () {
        return  {
            mdiWindowMaximize,
            mdiFilter,
            mdiDownload,
            mdiMagnify,
            searchQuery: null,
            search: null,
            loading: false,
            frDate: moment().subtract(3, 'days').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            currentItem: 'tab-VALIDATION LOGS',
            currentDownloadOpanNo: null,
            items: [
                'VALIDATION LOGS'
            ],
            headers: [],
            data: [],
            screen_width: document.documentElement.clientWidth + 9
        }
    },
    computed: {
        ...mapGetters(['getProviderValidationLogs']),
        modifiedHeaders() {
            // Return a new array without the last element
            if (this.currentItem === 'tab-APPROVAL LOGS') {
                return this.headers.slice(0, -1)
            } else {
                return this.headers
            }
        }
    },
    watch: {
        searchQuery(newVal) {
            if (newVal === '' || newVal === undefined || newVal === null) this.search = ''
        },
        async currentItem(newVal) {
            if (newVal) {
                const params = { FR_DATE: this.frDate, TO_DATE: this.toDate }
                await this.getData(newVal, params)
            }
        }
    },
    async mounted(){
        window.addEventListener('resize', this.onResize)
        this.getData(this.currentItem, { FR_DATE: this.frDate, TO_DATE: this.toDate })
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'fetchProviderValidationLogs']),
        async getData(name, params = null) {
            this.headers = []
            this.data = []
            this.loading = true
            let sortable = false
            // await this.getCsrfToken()
            if (name === 'tab-VALIDATION LOGS') {
                await this.fetchProviderValidationLogs(params)
                let fetch_result = this.getProviderValidationLogs.data
                this.data = Array.isArray(fetch_result) ? fetch_result : [fetch_result]
                sortable = false
            }
            this.headers = (this.data).length > 0 ? Object.keys(this.data[0]).map(key => ({
                text: key,
                value: key,
                sortable,
                class: 'providerAdminValidateLogsHeaders'
            })) : []
            this.loading = false
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.providerAdminValidateLogs h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.providerAdminValidateLogs .docInfoBody {
    margin-top: 5%;
    padding: 1% 3% 3% 3%;
}
.providerAdminValidateLogsHeaders {
    text-wrap: nowrap;
}
</style>
